<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <div class="mat-display-1 my-0 my-sm-24 welcome-message">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'CAR_LIST' |translate}}</span>
            </div>

            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px grid">
                <div fxFlex>
                    <button (click)="refresh()" mat-raised-button>
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
                <div fxFlex>
                    <button mat-raised-button (click)="addCar()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <!-- / HEADER -->

        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" matSortActive="id"
                    matSortDirection="asc" fusePerfectScrollbar>

                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let car">
                            {{car.id!=null?car.id:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="plate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'PLATE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let car">
                            {{car.plate!=null?car.plate:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="imei">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Imei'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let car">
                            {{car.imei!=null?car.imei:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="poligon">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'REGION'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let car">
                            {{car.poligon!=null?car.poligon.name:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="eLatitude">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'LOCATION'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let car">
                            <a *ngIf="car.eLatitude" matTooltip="{{car.eLatitude+'/'+car.eLongitude}}"
                                href="javascript:void(null)" (click)="onCarMap(car)">
                                <mat-icon>map</mat-icon>
                            </a>
                            <span *ngIf="!car.eLatitude">---</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let car">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="updateCar(car)">
                                    <mat-icon>edit</mat-icon>
                                    <span>{{'UPDATE'|translate}}</span>
                                </button>
                                <button mat-menu-item (click)="deleteCar(car)">
                                    <mat-icon>delete</mat-icon>
                                    <span>{{'DELETE'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let car; columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>

                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>